export default __webpack_public_path__ + "static/media/kid15.a293cb87.jpg";